import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { mobilitySurveyMaxDurations, mobilitySurveyMaxDurationsInMin } from '../../models';
import StatsCard from './stats-card';
export const transportHabitsDurationsMap = {
  '15': {
    bgColor: '#fff',
    sliderColor: '#2ac682',
    emoji: '🐆'
  },
  '30': {
    bgColor: '#f3f6ff',
    sliderColor: '#528be8',
    emoji: '🐎'
  },
  '45': {
    bgColor: '#fff5d0',
    sliderColor: '#ebaf25',
    emoji: '🐇'
  },
  '60': {
    bgColor: '#ffeee0',
    sliderColor: '#e06621',
    emoji: '🐢'
  },
  more: {
    bgColor: '#fff3f3',
    sliderColor: '#d34949',
    emoji: '🐌'
  }
};
export function TransportHabitsDurations({
  progressBarWidth,
  stats,
  children
}) {
  const [items, setItems] = useState();
  const {
    t
  } = useTranslation();
  useEffect(() => {
    setItems(stats ? mobilitySurveyMaxDurations.map(key => ({
      key,
      label: t(key === 'more' ? 'commons.transport_habits.durations.more_than' : 'commons.transport_habits.durations.less_than', {
        duration: key === 'more' ? mobilitySurveyMaxDurationsInMin[mobilitySurveyMaxDurationsInMin.length - 1] : key
      }),
      count: stats.durations[key] || 0,
      progressBarColor: transportHabitsDurationsMap[key].sliderColor
    })) : undefined);
  }, [stats]);
  return /*#__PURE__*/React.createElement(StatsCard, {
    items: items,
    progressBarWidth: progressBarWidth,
    respondantsCount: stats?.demotivationReasonsRespondantsCount,
    title: t('commons.transport_habits.durations.title')
  }, children);
}